import styled from 'styled-components';

export const PageContent = styled.div`
  margin: 1rem 1rem 5rem;
`;
